export { IRefreshInterval } from './refresh-interval';
export { ITransplantDetails } from './transplant-details';
export { IOption } from './option';

export const DateProperties = {
    DEADLINE_DATETIME: "DEADLINE_DATETIME",
    KICKOFF_DATETIME: "KICKOFF_DATETIME",
    LOGISTICS_DATETIME: "LOGISTICS_DATETIME",
    KIDNEY_PICKUP: "KIDNEY_PICKUP",
    KIDNEY_ARRIVAL: "KIDNEY_ARRIVAL",
    MATCH_OFFER_DEADLINE: "MATCH_OFFER_DEADLINE",
    DONOR_CLEARANCE_DEADLINE: "DONOR_CLEARANCE_DEADLINE",
}